import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { ReactComponent as ExportIcon } from '../../../../assets/icons/export.svg';
// import { ReactComponent as FilterClose } from '../../../../assets/icons/filter-close.svg';
// import { ReactComponent as Filter } from '../../../../assets/icons/filter.svg';
import { ReactComponent as GridList } from '../../../../../assets/icons/grid-list.svg';
// import { ReactComponent as SizeChangeIcon } from '../../../../../assets/icons/size-change-icon.svg';
import { ReactComponent as TableList } from '../../../../../assets/icons/table-list.svg';
// To-Do -> Need to change logo and name based on branding...
import BarcodeImage from '../../../../../assets/images/device-management/barcode.png';
import EnergicX from '../../../../../assets/images/device-management/energic-x.png';
import RfidLogo from '../../../../../assets/images/device-management/rfid-logo.png';
import { RfidCardProperties } from '../../../../../interface/rfid-cards.interface';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  fetchRfidCards,
  fetchRfidCardsFilters,
  refreshRfidCards,
  updateRfidCarFilters,
} from '../../../../../redux/slices/RfidManagementSlice';
import MyButton from '../../../../../shared-components/button/Button';
import CustomTableHeaderV2 from '../../../../../shared-components/custom-table/components/TableHeaderV2';
import CustomTable from '../../../../../shared-components/custom-table/CustomTable';
import { GetParametersFromCommonFilters } from '../../../../../shared-functions/CommonFilters';

/**
 * Component to display list of rfid cards associated with device
 * @returns {any} The result
 */
function RfidCards() {
  const { t } = useTranslation('devices');
  const dispatch = useAppDispatch();
  const { rfidCards, limit, page, loading, totalPages, totalResults, filterListLoading, filters } =
    useAppSelector((s) => s.rfidCard);

  const { selectedChargingPoint } = useAppSelector((s) => s.device);
  const [rfidView, setRfidView] = useState<'table' | 'grid'>('table');
  const [tableSize, setTableSize] = useState<'small' | 'medium' | 'large'>('small');

  const column = [
    {
      label: t('date'),
      accessorKey: 'createdAt' as keyof RfidCardProperties,
      sortAllow: true,
    },
    {
      label: t('name'),
      accessorKey: 'userName' as keyof RfidCardProperties,
      sortAllow: true,
    },
    {
      label: t('rfidNo'),
      accessorKey: 'rfidNo' as keyof RfidCardProperties,
      sortAllow: true,
    },
  ];

  /**
   * Function to handle auto refresh
   */
  const handleAutoRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);

    dispatch(
      refreshRfidCards({
        ...queryParameters,
        page,
        limit,
        chargingPointSn: selectedChargingPoint?.chargingPointSn || '',
      }),
    );
  };

  /**
   * Function to handle table size change
   */
  const handleChangeTableSize = () => {
    if (tableSize === 'small') {
      setTableSize('medium');
    } else if (tableSize === 'medium') {
      setTableSize('large');
    } else if (tableSize === 'large') {
      setTableSize('small');
    }
  };

  useEffect(() => {
    if (selectedChargingPoint) {
      const queryParameters = GetParametersFromCommonFilters(filters);

      dispatch(
        fetchRfidCards({
          chargingPointSn: selectedChargingPoint?.chargingPointSn || '',
          ...queryParameters,
        }),
      );
    }
  }, [filters, selectedChargingPoint]);

  return (
    <div className="device-rfid-cards-wrap">
      <div className="device-rfid-filters">
        <MyButton
          label=""
          buttonType="primary-outline"
          onClickFunc={() => setRfidView('table')}
          svgIcon={<TableList />}
        />
        <MyButton
          label=""
          buttonType="primary-outline"
          onClickFunc={() => setRfidView('grid')}
          svgIcon={<GridList />}
        />
        <CustomTableHeaderV2
          currentFontSize={tableSize}
          sizeChangeButtonRequired
          sizeChangeFunction={handleChangeTableSize}
          filters={filters}
          filtersToDispatch={updateRfidCarFilters}
          filterListToDispatch={fetchRfidCardsFilters}
          filterListLoading={filterListLoading || false}
        />
      </div>
      <div className="device-rfid-cards-toggle-wrap">
        {rfidView === 'grid' && (
          <div className="device-rfid-cards-container">
            {rfidCards.map((card) => (
              <div className="each-rfid-card-container">
                <div className="rfid-top-container">
                  <div className="rfid-top-logos">
                    <img src={RfidLogo} alt="" className="enegic-icon" />
                    <img src={EnergicX} alt="" className="enegic-text" />
                  </div>
                  <div className="card-number-wrap">
                    {Array(12)
                      .fill(null)
                      .map((_, index) => (
                        <>
                          <div className="card-number-dot" key={index} />
                          {(index + 1) % 4 === 0 && index !== 15 && (
                            <div className="card-number-gap" key={`gap-${index}`} />
                          )}
                        </>
                      ))}
                    <p>{card.rfidNo.slice(-4)}</p>
                  </div>
                </div>
                <div className="rfid-bottom-container">
                  <h2>{card.userName}</h2>
                  <img src={BarcodeImage} alt="" className="rfid-bar-code" />
                </div>
              </div>
            ))}
          </div>
        )}
        {rfidView === 'table' && (
          <div className="table-container">
            <CustomTable
              header={column}
              data={rfidCards}
              serialNo
              filter={{}}
              filterClearFunction={() => {}}
              filterFunction={() => {}}
              actionButton={false}
              limit={limit}
              page={page}
              loading={loading}
              totalPages={totalPages}
              totalResults={totalResults}
              pageLimitChange={(value: any) => {
                console.log(value);
              }}
              requiredRefreshToggle
              refreshFunction={handleAutoRefresh}
              sizeChangeButtonRequired
              disablePagination
              disableHeader
              height={400}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default RfidCards;
